import * as React from "react";
import {Icon, Tooltip} from "@vidazoo/ui-kit";
import theme from "../../../view/theme.module.scss";

export interface IRowCompareToggleProps {
    isBaseline: boolean;
    onCompare: () => void;
    onStop: () => void;
}

const CompareIcon = () => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M2 5h10M9 2l3 3-3 3"/>
        <path d="M14 11H4M7 8l-3 3 3 3"/>
    </svg>
);

/**
 * Appears on row hover in the first cell, next to the existing quick-filter action.
 * The baseline row keeps a visible chip that stops the comparison.
 */
export default React.memo(function RowCompareToggle({isBaseline, onCompare, onStop}: IRowCompareToggleProps): React.JSX.Element {
    if (isBaseline) {
        return (
            <Tooltip title="Stop comparing" position="top">
                <button type="button" className={theme.baselineChip} onClick={onStop} aria-label="Stop comparing rows">
                    Baseline
                    <Icon iconName="icon-cancel-small" size={1.2}/>
                </button>
            </Tooltip>
        );
    }

    return (
        <Tooltip title="Compare all rows to this one" position="top">
            <button type="button" className={theme.rowCompare} onClick={onCompare} aria-label="Compare all rows to this one">
                <CompareIcon/>
            </button>
        </Tooltip>
    );
});
